import { cn } from 'src/shared/components/ui';

interface ImagePreviewProps {
  src: string;
  alt: string;
  className?: string;
  onError?: () => void;
}

/**
 * Component for rendering image previews with consistent styling
 */
export function ImagePreview({
  src,
  alt,
  className,
  onError
}: ImagePreviewProps): React.ReactElement {
  return (
    <img
      draggable={false}
      src={src}
      alt={alt}
      className={cn(
        'h-full w-full object-contain rounded-2xl border border-gray-4 bg-gray-2',
        className
      )}
      onError={onError}
    />
  );
}
